/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { Audit, AuditFromJSON, AuditFromJSONTyped, AuditToJSON } from './Audit'
import { CompanyMemo, CompanyMemoFromJSON, CompanyMemoFromJSONTyped, CompanyMemoToJSON } from './CompanyMemo'
import {
  EnumTimelineContentType,
  EnumTimelineContentTypeFromJSON,
  EnumTimelineContentTypeFromJSONTyped,
  EnumTimelineContentTypeToJSON
} from './EnumTimelineContentType'
import { UserOperation, UserOperationFromJSON, UserOperationFromJSONTyped, UserOperationToJSON } from './UserOperation'

/**
 *
 * @export
 * @interface CompanyTimeline
 */
export interface CompanyTimeline {
  /**
   *
   * @type {string}
   * @memberof CompanyTimeline
   */
  id?: string
  /**
   *
   * @type {EnumTimelineContentType}
   * @memberof CompanyTimeline
   */
  contentType?: EnumTimelineContentType
  /**
   *
   * @type {Array<EnumTimelineContentType>}
   * @memberof CompanyTimeline
   */
  contentTypes?: Array<EnumTimelineContentType>
  /**
   *
   * @type {string}
   * @memberof CompanyTimeline
   */
  createdAt?: string
  /**
   *
   * @type {string}
   * @memberof CompanyTimeline
   */
  updatedAt?: string
  /**
   *
   * @type {UserOperation}
   * @memberof CompanyTimeline
   */
  userOperation?: UserOperation
  /**
   *
   * @type {CompanyMemo}
   * @memberof CompanyTimeline
   */
  memo?: CompanyMemo
  /**
   *
   * @type {Audit}
   * @memberof CompanyTimeline
   */
  audit?: Audit
}

export function CompanyTimelineFromJSON(json: any): CompanyTimeline {
  return CompanyTimelineFromJSONTyped(json, false)
}

export function CompanyTimelineFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyTimeline {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    contentType: !exists(json, 'content_type') ? undefined : EnumTimelineContentTypeFromJSON(json['content_type']),
    contentTypes: !exists(json, 'content_types')
      ? undefined
      : (json['content_types'] as Array<any>).map(EnumTimelineContentTypeFromJSON),
    createdAt: !exists(json, 'created_at') ? undefined : json['created_at'],
    updatedAt: !exists(json, 'updated_at') ? undefined : json['updated_at'],
    userOperation: !exists(json, 'user_operation') ? undefined : UserOperationFromJSON(json['user_operation']),
    memo: !exists(json, 'memo') ? undefined : CompanyMemoFromJSON(json['memo']),
    audit: !exists(json, 'audit') ? undefined : AuditFromJSON(json['audit'])
  }
}

export function CompanyTimelineToJSON(value?: CompanyTimeline | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    content_type: EnumTimelineContentTypeToJSON(value.contentType),
    content_types:
      value.contentTypes === undefined
        ? undefined
        : (value.contentTypes as Array<any>).map(EnumTimelineContentTypeToJSON),
    created_at: value.createdAt,
    updated_at: value.updatedAt,
    user_operation: UserOperationToJSON(value.userOperation),
    memo: CompanyMemoToJSON(value.memo),
    audit: AuditToJSON(value.audit)
  }
}
